<template>
  <div>
    <div class="lg:flex md:flex mb-4">
      <div class="location-home">
        <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3>
      </div>
    </div>
    <div class="flex gap-2 ml-auto w-full lg:mt-0 md:mt-0 mt-4">
      <!-- <b-form-input
        id="input-default"
        label-size="large"
        v-model="searchVal"
        class="cudtinput"
        placeholder="Search"
      ></b-form-input> -->
      <!-- <el-select placeholder="Location" class="">
        <el-option disabled="true">Select Channel...</el-option>
        <el-option>Private Channel</el-option>
        <el-option>Public Channel</el-option>
      </el-select>
      <el-select placeholder="Service Provider" class="">
        <el-option disabled="true">Select Channel...</el-option>
        <el-option>Private Channel</el-option>
        <el-option>Public Channel</el-option>
      </el-select> -->
      <!-- <div class="search">
        <base-button
          outline
          @click="handleSearch"
          type="primary"
          class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-2 py-1 fs16700 border-2"
          >Search</base-button
        >
      </div> -->
    </div>
    <div class="flex" v-show="!dataFound">
      <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["location"],
  data() {
    return {
      dataFound: false,
      searchVal: "",
    };
  },
  methods: {
    async handleSearch() {
      // console.log(this.searchVal)
      await this.$store.dispatch("respitecare/get_volunteerbylocation", {
        location: this.get_location.toLowerCase(),
        search: this.searchVal,
      });
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
  },
  mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.cudtinput {
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  height: 40px !important;
}
</style>
